import React, { useState } from "react";
import { TableProvider } from "../../context/TableContext";
import TsaBilling from "../../components/TsaBilling";
import styles from "./index.module.css";

const TsaBillingPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  return (
    <div className={styles.mainContainer}>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <h4>Tsa Billing</h4>
        </div>
      </div>

      <TableProvider>
        <TsaBilling />
      </TableProvider>
    </div>
  );
};

export default TsaBillingPage;
